<template>
    <div class="wrapper">
        <div class="ew" v-if="dialogVisible2">
            <img src="../assets/bg3.png" alt="" class="bg">
            <div class="ew_box">
                <div class="loginBox">
                    <div class="boxHeader">安全登錄，防止被騙</div>
                    <canvas id="qrcode" class="ews"></canvas>
                    <div class="intro">使用MOMI手機版掃描二維碼</div>
                    <div class="boxfoot">入口在MOMI手機端 &gt; 我的 &gt; 左上角掃一掃</div>
                </div>
            </div>
        </div>
        <div class="box" v-else>
            <div v-if="user.sid && token && !fileShow">
                <div class="userInfo">
                    <div class="user_l">
                        <div class="avatar">
                            <img :src="user.avatar" alt="">
                        </div>
                        <div class="user_con">
                            <div class="user_name">
                                <span class="name">{{user.nick}}</span>
                                <span class="login_out" @click="loginOut()">退出當前賬號</span>
                            </div>
                            <div class="user_id">MOMI ID：{{user.erbanNo}}</div>
                        </div>
                    </div>
                    <div class="user_r">
                        <div class="num">已上傳：<span>{{totalPage}}首</span> </div>
                        <div class="upload_btn" @click="openFile()">上傳歌曲</div>
                    </div>
                </div>

                <div class="bo_bottom">
                    <div class="delet">
                        <div class="delet_tit">已上傳歌曲</div>
                        <!-- <div class="delet_btn" @click="delSong()">刪除</div> -->
                    </div>
                    <el-table :data="list" stripe style="width: 100%" 
                    :header-cell-style="{ 'text-align': 'center',background:'#F0F0F0',color:'#262626' }" 
                    :cell-style="{ 'text-align': 'center' }" header-cell-class-name="table_header" 
                    @selection-change="handleSelectionChange">
                        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                        <el-table-column prop="id" label="歌曲ID"></el-table-column>
                        <el-table-column prop="title" label="歌曲名"></el-table-column>
                        <el-table-column prop="artist" label="演唱者"></el-table-column>
                        <el-table-column prop="src" label="歌曲" width="300">
                            <template slot-scope="scope">
                                <audio :src="scope.row.url" controls></audio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="size" label="大小">
                            <template slot-scope="scope">
                                {{scope.row.size | songSize}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="createDate" label="上傳時間" width="200">
                            <template slot-scope="scope">
                                {{scope.row.createDate | formatDate}}
                            </template>
                        </el-table-column>
                        <el-table-column label="狀態">
                            <template slot-scope="scope">
                                <span v-if="scope.row.songStatus == 0" class="color1">待審核</span>
                                <span v-if="scope.row.songStatus == 1" class="color2">已上架</span>
                                <span v-if="scope.row.songStatus == 2" class="color3">未通過</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" @click="delet(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background layout="prev, pager, next" :total="totalPage" :page-size="pageSize" 
                    @current-change="currentChange"></el-pagination>
                </div>
            </div>
            <div class="songFile" v-if="fileShow">
                <div class="file_tit" @click="openFile()">
                    <span>查看我已上傳的音樂</span>
                    <img src="../assets/jiantou.png" alt="">
                </div>
                <div class="file_con">
                    <div class="file_item">
                        <div class="item_tit">
                            <span class="item_tit_t">歌曲名</span>
                            <span class="item_tit_f">*</span>
                            <span class="item_tit_n">（必填，不超過30個字）</span>
                        </div>
                        <div class="item_con">
                            <el-input clearable class="item_input" v-model="fileObj.title"></el-input>
                        </div>
                    </div>
                    <div class="file_item">
                        <div class="item_tit">
                            <span class="item_tit_t">演唱者</span>
                            <span class="item_tit_f">*</span>
                            <span class="item_tit_n">（必填，不超過30個字，該信息不準確可能導致下架）</span>
                        </div>
                        <div class="item_con">
                            <el-input clearable class="item_input" v-model="fileObj.artist"></el-input>
                        </div>
                    </div>
                    <div class="file_item">
                        <div class="item_tit">
                            <span class="item_tit_t">音樂文件 </span>
                            <span class="item_tit_f">*</span>
                            <span class="item_tit_n">（必填，僅限MP3格式，不超過20M）</span>
                        </div>
                        <div class="item_con">
                            <el-upload class="upload-demo" ref="upload" :action="uploadUrl" :http-request="putSong"
                                :auto-upload="false" :on-remove="handleRemove" :multiple="false" accept="audio/mp3"
                                :limit="1" :file-list="fileList" :on-change="onChange">
                                <el-button size="small" type="primary">選擇音樂</el-button>
                                <div slot="tip" class="el-upload__tip">只能上傳MP3文件，且不超過20MB</div>
                            </el-upload>
                            <el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
                        </div>
                        <div class="file_item">
                            <div class="item_tit color3">僅支持上傳MP3格式文件，因修改格式導致播放失敗，屬正常現象</div>
                        </div>
                        <div class="file_item">
                            <div class="item_tit">
                                <span class="item_tit_t">音樂類型 </span>
                                <span class="item_tit_f">*</span>
                                <span class="item_tit_n">（必填）</span>
                            </div>
                            <div class="item_con">
                                <el-radio v-model="fileObj.type" label="0" size="medium" border>伴奏</el-radio>
                                <el-radio v-model="fileObj.type" label="1" size="medium" border>原唱</el-radio>
                            </div>
                        </div>
                        <div class="file_item">
                            <div class="item_con mgtop">
                                <el-checkbox v-model="fileObj.checked">我已認真閱讀並同意 <span class="xieyi">《MOMI用戶協議》</span> </el-checkbox>
                            </div>
                        </div>
                        <el-button type="primary" icon="el-icon-upload el-icon--right" class="addFile mgtop" @click.stop.prevent="updatedSinger" :disabled="progressFlag">確認上傳</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from "qrcode";
import { delCookie } from "@/utils/auth";
import { setTimeout, setInterval, clearInterval } from "timers";
import { Loading } from 'element-ui';
export default {
    name: "songList",
    components: { Loading },
    props: {},
    data() {
        return {
            uploadUrl: "",
            videoUpload: null,
            fileObj: {
                artist: '',
                title: '',
                type: '1',
                checked: false,
                urls: ''
            },
            songList: {
                percentage: 0
            },
            multipleSelection: null,
            dialogVisible1: false,
            dialogVisible2: false,
            url: "123456", //路径
            timeO: "", //轮询登录接口，获取登录凭证
            tiamD: "", //轮询二维码生成方法，防止失败
            uidd: "",
            token: "",
            bateUrl: "https://res.tongzhou666.com",
            fileList: [],
            fileItem: {},
            limen: 3,
            percent: "0",
            timeLogin: 0,
            pageNum: 1,
            pageSize: 10,
            totalPage: 0,
            fileShow: false,
            progressFlag: false,
            loadProgress: 0
        };
    },
    watch: {
        songList(a, b) {
            console.log(a, b, "songList");
        },
        pageNum(a, b) {
            console.log(a, b, "pageNum");
            // this.getSongList();
        }
    },
    computed: {
        url_() {
            return window.location.origin;
        },
        user() {
            return this.$store.state.user.user;
        },
        list() {
            return this.$store.state.user.list;
        }
    },
    methods: {
        currentChange(e){
            this.pageNum = e
            this.getSongList();
        },
        openFile() {
            this.fileShow = !this.fileShow
        },
        handleRemove(file, fileList) {
            this.fileList = [];
        },
        onChange(file, fileList) {
            console.log(file, fileList, "onChange");
            var that = this;
            var sizes = file.size / 1024 / 1024;
            if (file.raw.type.indexOf("audio") == -1) {
                this.$Message({
                    message: "請上傳MP3格式文件！",
                    type: "error"
                });
                this.songList = {};
                // this.$refs.upload.clearFiles();
                this.fileList = [];
                return false;
            } else {
                if (sizes > 20) {
                this.$Message({
                    message: "音樂文件限制大小不超過20MB！",
                    type: "error"
                });
                this.songList = {};
                this.$refs.upload.clearFiles();
                return false;
                } else {
                this.fileItem = file;
                this.fileObj.size = file.size;
                const url = URL.createObjectURL(file.raw);
                const audio = new Audio(url);
                // 计算音频的时长
                audio.addEventListener("loadedmetadata", function(_event) {
                    console.log("音頻時長", audio.duration);
                    that.fileObj.duration = audio.duration;
                });
                }
            }
        },
        async updatedSinger() {
            var that = this;
            if (!this.fileObj.title) {
                this.$Message({
                    message: "請輸入歌曲名！",
                    type: "error"
                });
            } else if (!this.fileObj.artist) {
                this.$Message({
                    message: "請輸入演唱者！",
                    type: "error"
                });
            } else if (Object.keys(this.fileItem).length === 0) {
                this.$Message({
                    message: "請上傳音樂！",
                    type: "error"
                });
            } else if (!this.fileObj.checked) {
                this.$Message({
                    message: "請勾選協議！",
                    type: "error"
                });
            } else {
                const randomNum = () =>
                    (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
                const randomName = () => {
                    return `${randomNum()}-${randomNum()}-${randomNum()}-${randomNum()}-${randomNum()}`;
                };
                let keyName2 = "song/" + randomName() + ".mp3";
                this.fileObj.urls = "https://res.tongzhou666.com/" + keyName2;
                that.getSignedUrl(keyName2).then(function(res) {
                    that.uploadUrl = res.data;
                    that.$refs.upload.submit();
                });
            }
        },
        async singUpload(e) {
            //上传歌曲七牛路径
            let that = this;
            await this.$axios({
                method: "post",
                url: that.url_ + "/item/song/v2/upload",
                params: {
                    uid: that.user.uid,
                    sid: that.user.sid,
                    url: that.fileObj.urls,
                    type: that.fileObj.type,
                    title: that.fileObj.title,
                    artist: that.fileObj.artist,
                    size: that.fileObj.size,
                    duration: that.fileObj.duration
                }
            })
                .then(result => {
                    if (result.code == "200") {
                        this.$Message({ message: "上傳成功", type: "success" });
                        this.fileObj = {
                            artist: "",
                            title: "",
                            type: "1",
                            checked: false,
                            urls: ""
                        };
                        // this.fileObj = {}
                        this.$refs.upload.clearFiles();
                        this.songList = {};
                        this.getSongList();
                        this.fileList = [];
                        this.fileItem = {};
                        this.fileShow = false;
                    } else {
                        this.fileObj = {
                            artist: "",
                            title: "",
                            type: "1",
                            checked: false,
                            urls: ""
                        };
                        this.fileItem = {};
                        this.fileList = [];
                        this.songList = {};
                        this.getSongList();
                    }
                    this.loadProgress = 0;
                })
                .catch(res => {
                    console.log(res);
                    this.$Message({
                        message: "上傳失敗，請稍後重試",
                        type: "error"
                    });
                    this.fileItem = {};
                    this.songList = {};
                    this.fileObj = {
                        artist: "",
                        title: "",
                        type: "1",
                        checked: false,
                        urls: ""
                    };
                    this.loadProgress = 0;
                    this.$refs.upload.clearFiles();
                });
        },
        loginOut() {
            this.$confirm('是否確認退出當前賬號?', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delCookie("token");
                localStorage.removeItem("user", null);
                this.$store.commit("setUser", {});
                this.$store.commit("setActive", 0);
                this.$store.commit("setList", []);
                this.$Message({
                    type: 'success',
                    message: '退出成功!'
                });
            }).catch(() => {
            });
        },
        showLogin() {
            this.getToken().then(e => {
                // console.log(e,111);
                this.dialogVisible2 = true;
                if (e.code == 200 && e.data) {
                    this.uidd = e.data;
                    setTimeout(() => {
                        this.qrcode(e.data);
                    }, 100);
                }
            });
        },
        handleSelectionChange(e) {
            // console.log(e);
            this.multipleSelection = e;
        },
        async qrcode(e) {
            //生成二维码
            if (!e) return;
            let that = this;
            this.timeLogin = 120;
            let canvas = document.getElementById("qrcode");
            // let canvas =this.$refs.qrcode;
            if (!canvas) {
                return false;
            }
            QRCode.toCanvas(canvas, e || "该功能暂未发布", function (error) {
                if (error) {
                    console.error(error);
                    that.tiamD = setTimeout(() => {
                        clearInterval(that.timeO);
                        that.timeO = null;
                        that.qrcode();
                        console.log("重新生成二维码");
                    }, 1200);
                }
                that.timeO = setInterval(() => {
                    that.Login();
                    that.timeLogin = --that.timeLogin;
                    if (that.timeLogin < 1) {
                        clearInterval(that.timeO);
                        that.timeO = null;
                        that.timeLogin = 0;
                    }
                }, 1000);
            });
        },
        async getToken() {
            //二维码信息
            let that = this;
            let res = null;
            await this.$axios({
                method: "get",
                url: that.url_ + "/acc/qrCode/genCode?type=1"
            }).then(result => {
                res = result;
            });
            return res;
        },
        delet(e) {
            this.$confirm('是否確認删除當前歌曲?', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delSong(e)
            }).catch(() => {

            });
        },
        async delSong(e) {
            //   console.log(e);
            if (!e.id) {
                return false;
            }
            await this.$axios({
                method: "get",
                url: this.url_ + "/item/song/v2/del",
                params: {
                    uid: this.user.uid,
                    sid: this.user.sid,
                    songId: e.id
                }
            }).then(result => {
                    this.$Message({
                        message: "删除成功！",
                        type: "success"
                    });
                    this.getSongList();
                })
                .catch(e => {
                    this.$Message({
                        message: "删除失败，請稍後重試！",
                        type: "error"
                    });
                });
        },
        async getUpToken() {
            //获取上传七牛token
            let that = this;
            let res = null;
            await this.$axios({
                method: "get",
                url: that.url_ + "/item/song/getUploadToken",
                params: {
                    uid: that.user.uid,
                    sid: that.user.sid
                }
            }).then(result => {
                // console.log(result, "getUpToken");
                if (result.code == 200) {
                    this.token = result.data;
                    this.pppss.token = result.data;
                    // console.log(this.pppss);
                } else {
                    setTimeout(() => {
                        that.limen = that.limen--;
                        if (that.limen < 1) {
                            that.getUpToken();
                        }
                    }, 1000);
                }
            });
        },
        async getSongList() {
            //获取歌曲列表
            let that = this;
            let res = null;
            await this.$axios({
                method: "get",
                url: that.url_ + "/item/song/v2/songList",
                params: {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    uid: that.user.uid,
                    sid: that.user.sid
                }
            })
                .then(result => {
                    // console.log(result, "getSongList");
                    this.totalPage = result.data.songCount;
                    this.$store.commit("setList", result.data.songList);
                })
                .catch(e => {
                    // console.log(e);
                });
        },
        async Login() {
            //轮询登录
            let that = this;
            let res = null;
            await this.$axios({
                method: "get",
                url: that.url_ + "/acc/qrCode/getUser",
                params: {
                    qrCode: that.uidd
                }
            }).then(result => {
                if (result.code == 200) {
                    this.$Message({
                        message: "登錄成功！",
                        type: "success"
                    });
                    localStorage.setItem("user", JSON.stringify(result.data));
                    this.$store.commit("setUser", result.data);
                    this.dialogVisible2 = false;
                    clearInterval(that.timeO);
                    that.timeO = null;
                    that.timeLogin = 0;
                    this.getSongList();
                    this.getUpToken();
                }
                if(result.code == 404){
                    this.getToken().then(e => {
                        this.dialogVisible2 = true;
                        if (e.code == 200 && e.data) {
                            this.uidd = e.data;
                            setTimeout(() => {
                                this.qrcode(e.data);
                            }, 100);
                        }
                    });
                }
            });
        },
        async getSignedUrl(keyName) {
            let that = this;
            let data;
            await this.$axios({
                method: "get",
                url: that.url_ + "/item/song/signedUrl",
                params: {
                    keyName,
                    uid: that.user.uid,
                    sid: that.user.sid
                }
            }).then(result => {
                data = result;
            });
            return data;
        },
        async putSong(item) {
            let that = this;
            await this.$axios({
                method: "put",
                url: that.uploadUrl,
                data: item.file,
                onUploadProgress: node => {
                    let tempProgress = node.loaded / node.total; //上传进度
                    that.progressFlag = true;
                    that.loadProgress = parseInt(tempProgress * 100);
                if (tempProgress == 1) {
                    that.progressFlag = false;
                }
                }
            })
                .then(res => {
                    that.singUpload();
                    return res;
                })
                .catch(e => {
                    console.log(e);
                    this.loadProgress = 0;
                    this.$refs.upload.clearFiles();
                    this.fileObj = {
                        artist: "",
                        title: "",
                        type: "1",
                        checked: false,
                        urls: ""
                    };
                    this.songList = {};
                    this.getSongList();
                    this.fileList = [];
                    this.fileItem = {};
                    that.$Message({
                        message: "上傳失敗，請稍後重試",
                        type: "error"
                    });
                });
        }
    },
    created() {
        if (localStorage.getItem("user")) {
            this.$store.commit("setUser", JSON.parse(localStorage.getItem("user")));
            this.dialogVisible2 = false;
            this.getSongList();
            this.getUpToken();
        } else {
            this.getToken().then(e => {
                // console.log(e,111);
                this.dialogVisible2 = true;
                if (e.code == 200 && e.data) {
                    this.uidd = e.data;
                    setTimeout(() => {
                        this.qrcode(e.data);
                    }, 100);
                }
            });

        }
        // console.log(this.user)
    },
    mounted: () => {
        // console.log(window.location.origin);
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-upload-dragger {
    width: 100%;
    height: auto;
    border: none;
}
.song_name {
    color: #555555;
    font: 400 0.625vw/1vw PingFangSC-Regular, PingFang SC;
    margin: 0 1vw;
}
.song_tit {
    color: #555555;
    font: 400 0.625vw/1vw PingFangSC-Regular, PingFang SC;
}
.xieyi {
    color: #ffb300;
}
.mgtop {
    margin-top: 1.2vw;
}
.color1 {
    color: #3b5bff;
}
.color2 {
    color: #555555;
}
.color3 {
    color: #ff4d4d;
}
.fileFooter {
    display: flex;
    align-items: center;
}
.wrapper {
    width: 100%;
    background: #f8f8f8;
    padding-bottom: 20px;
    z-index: 10;
    position: absolute;
    left: 0;
    top: 5.365vw;
    .ew {
        width: 100%;
        height: auto;
        position: relative;
        .bg {
            width: 100%;
            height: auto;
        }
        .ew_box {
            position: absolute;
            width: 20vw;
            height: 24vw;
            left: 50%;
            top: 8.5vw;
            z-index: 12;
            margin-left: -10vw;
            background: #ffffff;
            border-radius: 30px;
            .loginBox {
                text-align: center;
                .boxHeader {
                    color: #262626;
                    text-align: center;
                    font: bold 1vw/1vw PingFangSC-Regular, PingFang SC;
                    padding: 3vw 0 1vw;
                }
                #qrcode {
                    width: 12vw !important;
                    height: 12vw !important;
                    margin: 0 auto;
                    display: block;
                }
                .intro {
                    width: 13vw;
                    height: 2vw;
                    color: #555555;
                    text-align: center;
                    font: bold 0.625vw/2vw PingFangSC-Regular, PingFang SC;
                    background: #f2f2f2;
                    border-radius: 1vw;
                    margin: 0 auto;
                }
                .boxfoot {
                    color: #555555;
                    text-align: center;
                    font: bold 0.57vw/3vw PingFangSC-Regular, PingFang SC;
                }
            }
        }
    }
    .box {
        margin: 0 auto;
        width: 63vw;
        min-height: 100vh;
        box-sizing: border-box;
        padding-top: 10px;
        display: flex;
        flex-direction: column;
        background: rgba(247, 247, 247, 1);
        .userInfo {
            width: 100%;
            height: 8.5vw;
            background: #ffffff;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 2vw;
            .user_l {
                display: flex;
                align-items: center;
                .user_con {
                    margin-left: 20px;
                    .user_name {
                        display: flex;
                        align-items: center;
                        .name {
                            color: #262626;
                            font: 400 1vw/1vw PingFangSC-Regular, PingFang SC;
                        }
                        .login_out {
                            margin-left: 5px;
                            color: #ffb300;
                            font: 400 0.65vw/1vw PingFangSC-Regular, PingFang SC;
                            text-decoration: underline;
                            cursor: pointer;
                        }
                    }
                    .user_id {
                        color: #999999;
                        margin-top: 10px;
                        font: 400 0.6vw/1vw PingFangSC-Regular, PingFang SC;
                    }
                }
                .avatar img {
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                }
            }
            .user_r {
                .num {
                    display: flex;
                    align-items: center;
                    color: #262626;
                    font: 400 0.95vw/1vw PingFangSC-Regular, PingFang SC;
                    span {
                        font: bold 0.95vw/1vw PingFangSC-Regular, PingFang SC;
                        color: #ffb300;
                    }
                }
                .upload_btn {
                    width: 5.4vw;
                    height: 1.8vw;
                    text-align: center;
                    font: 400 0.75vw/1.8vw PingFangSC-Regular, PingFang SC;
                    color: #262626;
                    background: #ffd143;
                    border-radius: 6px;
                    margin-top: 20px;
                    cursor: pointer;
                }
            }
        }
        .bo_bottom {
            width: 100%;
            background: #fff;
            box-sizing: border-box;
            border-radius: 10px;
            .delet {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 20px;
            }
            .delet_tit {
                color: #262626;
                font: 400 1vw/1vw PingFangSC-Regular, PingFang SC;
            }
            .delet_btn {
                width: 5.4vw;
                height: 2vw;
                text-align: center;
                color: #ffb300;
                font: 400 0.75vw/1.8vw PingFangSC-Regular, PingFang SC;
                border: 2px solid #ffd143;
                border-radius: 1vw;
                cursor: pointer;
            }
        }
        .songFile {
            background: #fff;
            box-sizing: border-box;
            padding: 34px;
            border-radius: 10px;
            .file_tit {
                display: flex;
                align-items: center;
                cursor: pointer;
                span {
                    color: #ffb300;
                    font: 400 0.85vw/30px PingFangSC-Regular, PingFang SC;
                }
                img {
                    width: 30px;
                    height: 30px;
                }
            }
            .file_con {
                padding: 1.56vw 4.375vw;
                .file_item {
                    .item_tit {
                        display: flex;
                        align-items: center;
                        padding: 1.56vw 0 1.05vw;
                        .item_tit_t {
                            color: #262626;
                            font: 400 0.8vw/0.8vw PingFangSC-Regular,
                                PingFang SC;
                        }
                        .item_tit_f {
                            color: #ff1414;
                            font: bold 0.8vw/0.8vw PingFangSC-Regular,
                                PingFang SC;
                            margin: 0 3px;
                        }
                        .item_tit_n {
                            color: #999999;
                            font: 400 0.8vw/0.8vw PingFangSC-Regular,
                                PingFang SC;
                        }
                    }
                    .item_con {
                        width: 100%;
                        height: auto;
                        .item_input {
                            width: 16vw;
                            height: 2.2vw;
                            background: #f0f0f0;
                            border-radius: 6px;
                        }
                    }
                }
                .content {
                    height: 100%;
                    width: 100%;
                    box-sizing: border-box;
                    padding: 1vw 10px;
                    position: relative;
                    overflow: auto;
                    display: flex;
                    align-items: center;
                    .songList {
                        display: flex;
                        width: 100%;
                        height: 40px;
                        align-items: center;
                        justify-content: space-around;
                        > span {
                            margin-right: 50px;
                        }
                        > span:first-child {
                            flex-grow: 2;
                            text-align: left;
                        }
                    }
                    .upData {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                    }
                    .text {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
            .fileBox {
                display: flex;
                flex-direction: column;
                .fileHeader {
                    background: #eeeeee;
                    display: flex;
                    justify-content: flex-end;
                    height: 40px;
                    align-items: center;
                    box-sizing: border-box;
                    padding: 0 16px 0 10px;
                    span {
                        margin-right: 60px;
                    }
                    span:first-child {
                        flex-grow: 2;
                    }
                }
                .fileFooter {
                    display: flex;
                    justify-content: flex-end;
                    background: #eeeeee;
                    height: 40px;
                    align-items: center;
                    box-sizing: border-box;
                    padding: 0 16px 0 10px;
                    width: 100%;
                    position: relative;
                    .btn {
                        flex-grow: 2;
                        display: flex;
                        .addFile {
                            width: 97px;
                            height: 28px;
                            background: rgba(255, 255, 255, 1);
                            border: 1px solid rgba(0, 194, 255, 1);
                            border-radius: 14px;
                            color: #00c2ff;
                            font-size: 14px;
                            text-align: center;
                            padding: 0;
                        }
                    }
                    > span {
                        margin-right: 60px;
                    }
                }
                
                .content:-webkit-scrollbar {
                    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
                    height: 1px;
                }
                .content::-webkit-scrollbar {
                    /*滚动条整体样式*/
                    width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
                    height: 1px;
                }
                .content::-webkit-scrollbar-thumb {
                    /*滚动条里面小方块*/
                    border-radius: 10px;
                    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                    background: #535353;
                }
                .content::-webkit-scrollbar-track {
                    /*滚动条里面轨道*/
                    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                    border-radius: 10px;
                    background: #ededed;
                }
            }
        }
        .bo_bottom {
            min-height: 200px;
            background: rgba(255, 255, 255, 1);
            margin-top: 20px;
            padding: 22px;
            box-sizing: border-box;
            h2 {
                font-size: 22px;
                padding: 5px 0 26px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                > span:first-child {
                    position: relative;
                    span {
                        position: absolute;
                        left: 0;
                        bottom: -18px;
                        font-size: 16px;
                        color: #aaa;
                        font-weight: 400;
                        white-space: nowrap;
                    }
                }
                > span:last-child {
                    display: flex;
                    align-items: center;
                    > span {
                        display: inline-block;
                        width: 133px;
                        height: 45px;
                        line-height: 45px;
                        border: 2px solid rgba(11, 208, 206, 1);
                        box-sizing: border-box;
                        text-align: center;
                        border-radius: 23px;
                        font-size: 19px;
                        color: rgba(11, 208, 206, 1);
                        font-weight: 400;
                        cursor: pointer;
                    }
                    img {
                        width: 29px;
                        height: 29px;
                        margin-left: 26px;
                        cursor: pointer;
                    }
                }
            }
            .list {
                min-height: 200px;
                background: #ffffff;
                position: relative;
                .no {
                    background: #ffffff;
                    height: 650px;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    img {
                        width: 186px;
                    }
                    span {
                        font-size: 18px;
                        font-family: PingFang-SC-Medium;
                        font-weight: 500;
                        color: rgba(105, 105, 105, 1);
                        line-height: 40px;
                        margin-top: 20px;
                    }
                }
                .uls {
                    display: flex;
                    flex-direction: column;
                    .lis {
                        display: flex;
                        span {
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
    .songBtn {
        span {
            color: #00c2ff;
            cursor: pointer;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/songList.vue